module.exports = __webpack_public_path__ + "assets/img/es-56b7770d.png";